import { render, staticRenderFns } from "./singleValue.vue?vue&type=template&id=56a0aa2f&scoped=true&"
import script from "./singleValue.vue?vue&type=script&lang=js&"
export * from "./singleValue.vue?vue&type=script&lang=js&"
import style0 from "./singleValue.vue?vue&type=style&index=0&id=56a0aa2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a0aa2f",
  null
  
)

export default component.exports